
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bathroom-design-app",
      function () {
        return require("private-next-pages/bathroom-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bathroom-design-app"])
      });
    }
  